import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { environment } from '@/env/environment';
import { SsrService } from '@/common/services/ssr/ssr.service';
import { ConfigurationService } from '@/common/services/configuration/configuration.service';

@Component({
    selector: 'fe-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
    public currentLanguage: 'en' | 'es' = 'es';
    public idiomaChange: string | null = null;
    public currentLangtxt: string | null = null;
    public changeLangCode: 'es' | 'en' | null = null;
    public isMobileMenuOpen = false;
    public openSubmenuId: string | null = null;
    public env: any;

    constructor(
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
        private readonly ssr: SsrService,
        public readonly configuration: ConfigurationService,
    ) {
        this.currentLanguage = this.getLanguageUseCase.execute().language;
        this.initializeLanguageVariables();
    }

    ngOnInit(): void {
        this.env = environment;
        if (this.ssr.isPlatformServer()) {
            return;
        }
        document.addEventListener('click', this.handleClickOutside.bind(this));
    }

    ngOnDestroy(): void {
        if (this.ssr.isPlatformServer()) {
            return;
        }
        document.removeEventListener(
            'click',
            this.handleClickOutside.bind(this),
        );
    }

    private handleClickOutside(event: MouseEvent): void {
        const openSubmenus = document.querySelectorAll('.header__submenu.open');
        openSubmenus.forEach((submenu) => {
            if (!submenu.contains(event.target as Node)) {
                submenu.classList.remove('open');
                if (this.openSubmenuId === submenu.id) {
                    this.openSubmenuId = null;
                }
            }
        });
    }

    public onClickChangeLang(toLang: 'es' | 'en'): void {
        window.location.replace([environment.baseUrl, toLang].join('/'));
    }

    initializeLanguageVariables() {
        if (this.currentLanguage === 'es') {
            this.idiomaChange = 'Inglés';
            this.currentLangtxt = 'Español';
            this.changeLangCode = 'en';
        } else if (this.currentLanguage === 'en') {
            this.idiomaChange = 'Spanish';
            this.currentLangtxt = 'English';
            this.changeLangCode = 'es';
        } else {
            this.idiomaChange = null;
            this.currentLangtxt = null;
            this.changeLangCode = null;
        }
    }

    public toggleMobileMenu(): void {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
        const bodyElement = document.querySelector('body');
        if (bodyElement) {
            if (this.isMobileMenuOpen) {
                bodyElement.classList.add('sidebar-visible');
            } else {
                bodyElement.classList.remove('sidebar-visible');
            }
        } else {
            console.error('No se encontró el elemento <body>');
        }
    }

    public toggleSubmenu(id: string, event: Event): void {
        event.stopPropagation();
        const allSubmenus = document.querySelectorAll('.header__submenu');
        const menuSelected = document.querySelector('#' + id);

        if (menuSelected?.classList.contains('open')) {
            menuSelected.classList.remove('open');
            this.openSubmenuId = null;
            return;
        }

        allSubmenus.forEach((submenu) => {
            submenu.classList.remove('open');
        });

        menuSelected?.classList.add('open');
        this.openSubmenuId = menuSelected ? id : null;
    }
}
